import React, { FC } from 'react';
import { Box, BoxProps } from '@withjoy/joykit';
import { RenditionSize } from '@shared/utils/photoRendition';
import { useProgressiveImageUrl } from '../useProgressiveImageLoading';
import { animationTransition } from '@shared/utils/animationTransition';

interface ProgressiveImageProps {
  photoUrl: string;
  lowResRendition?: RenditionSize;
  highResRendition?: RenditionSize;
  width?: BoxProps['width'];
  height?: BoxProps['height'];
  imageStyles: BoxProps;
  containerStyles: BoxProps['style'];
}

export const ProgressiveImage: FC<ProgressiveImageProps> = props => {
  const { photoUrl, lowResRendition = 'medium', highResRendition = 'full', width = '100%', height = '100%', imageStyles, containerStyles } = props;

  const { lowResUrl, highResUrl, isHighResLoaded } = useProgressiveImageUrl({
    photoUrl,
    lowResRendition,
    highResRendition
  });

  return (
    <Box width={width} height={height} position="relative" style={containerStyles}>
      {/* Low-resolution image layer */}
      <Box
        {...imageStyles}
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        backgroundImage={lowResUrl ? `url(${lowResUrl}) lightgray 50%` : 'lightgray 50%'}
        opacity={isHighResLoaded ? 0 : 1}
        transition={animationTransition('opacity')}
        zIndex={1}
      />

      {/* High-resolution image layer */}
      {highResUrl && (
        <Box
          {...imageStyles}
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          backgroundImage={`url(${highResUrl}) lightgray 50%`}
          opacity={isHighResLoaded ? 1 : 0}
          transition={animationTransition('opacity')}
          zIndex={2}
        />
      )}
    </Box>
  );
};
